import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';

const PILLARS = [
  { icon: 'ri-goblet-line', title: 'Heritage', text: 'Traditional Indian styles and textile culture.' },
  { icon: 'ri-award-line', title: 'Quality', text: 'Carefully selected fabrics and designs.' },
  { icon: 'ri-hand-heart-line', title: 'Personal Service', text: 'Direct communication with the SRM Textiles team.' },
  { icon: 'ri-home-heart-line', title: 'UK Connection', text: 'Traditional Indian clothing made easier to discover in the UK.' },
];

export default function WhySrm() {
  return (
    <section className="bg-primary-950 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionLabel align="center" light>
            Why SRM Textiles
          </SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-background-50">
            A Brand You Can Trust
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PILLARS.map((item, i) => (
            <Reveal
              key={item.title}
              delay={i * 90}
              className="rounded-lg border border-background-50/10 bg-background-50/5 p-7"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500/15 text-accent-300">
                <i className={`${item.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-2xl font-semibold text-background-50">{item.title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-background-100/70">{item.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}